import { ChangeEvent } from "react";
import { State } from "../../client";
import { FilePreviewDisplay } from "../display";

// NOTE: Commented out lines are allowed by the specs but unused by our frontend.
export type FileData = {
  // Not the best name, but the encryption logic will replace Files with an url.
  url?: File | string;
  url$confidential?: File | string;
  filename?: string;
  filename$confidential?: string;
  type?: string;
  // type$confidential?: string;

  // $confidential?: {
  //   url: File | string;
  //   filename?: string;
  //   type?: string;
  // };
};

interface Props {
  state: State<FileData | null>;
}

export function FileRowInput({ state: [file, setFile] }: Props) {
  if (!file) return;

  const filename = file.filename ?? file.filename$confidential;
  const type = file.type;
  const url = file.url ?? file.url$confidential;
  const dataIsConfidential = file.url === undefined;

  const setFilename = (e: ChangeEvent<HTMLInputElement>) => {
    const out = { ...file };
    if (out.filename !== undefined) out.filename = e.target.value;
    if (out.filename$confidential !== undefined)
      out.filename$confidential = e.target.value;
    setFile(out);
  };
  const toggleDataConfidentiality = () => {
    const out = { ...file };
    if (out.url !== undefined) {
      out.url$confidential = out.url;
      delete out.url;
    } else {
      out.url = out.url$confidential;
      delete out.url$confidential;
    }
    setFile(out);
  };
  const remove = () => {
    setFile(null);
  };

  const isExternal = typeof url === "string";

  // NOTE: For now this only allows choosing between public and not public, but
  // in the future we may add an option for embed vs upload.
  // NOTE: There almost certainly is a better way to set the selection.
  const mode = (
    <select onChange={toggleDataConfidentiality}>
      <option
        selected={!dataIsConfidential}
        title="Everyone can view+download the data"
      >
        {isExternal ? "Public" : "Public (embed)"}
      </option>
      {/* <option>Encrypt (upload)</option> */}
      <option
        selected={dataIsConfidential}
        title={
          isExternal
            ? "Data is hosted somewhere else, only the url is hidden/encrypted"
            : "Only the current (or previous) owners of this NFT can view/download the data"
        }
      >
        {isExternal ? "Hide URL" : "Encrypt (embed)"}
      </option>
    </select>
  );

  return (
    <tr>
      <td>
        <input
          className="as-link-unless-focused"
          value={filename}
          onChange={setFilename}
        />
      </td>
      <td>{mode}</td>
      <td>{type}</td>
      <td>
        <FilePreviewDisplay file={url!} type={type}>
          {typeof url === "string" ? (
            <a href={url}>{url}</a>
          ) : (
            <span className="gray">Preview not available</span>
          )}
        </FilePreviewDisplay>
      </td>
      <td>
        <button onClick={remove}>Remove</button>
      </td>
    </tr>
  );
}
